var symphony = symphony || {};

;(function() {

	symphony.stickyFooter = function() {

		$(document).ready(function(){
			var windowHeight = $('body').outerHeight();
			var pageHeight = $('#page').outerHeight();
			var difference = windowHeight - pageHeight;

			if(difference > 0) {

				$('.globalFooter').css('bottom', -difference);
			}
		});

		

	};


})();